<template>
  <div>
    <nav-top Title="密码找回"></nav-top>
    <field-text
        label="注册邮箱"
        style="margin: 15px 0;"
        placeholder="请输入注册邮箱"
        ref = "mail"
        showButton=true
        :buttonMsg="buttonMessage"
        @handeClick="sendCode"
        @contentWatch="res => model.email = res"
    />
    <field-text
        label="验证码"
        style="margin: 15px 0;"
        placeholder="请输入验证码"
        ref="code"
        @contentWatch="res => model.code = res"
    />
    <field-text
        label="密码"
        style="margin: 15px 0;"
        placeholder="请输入密码"
        type="password"
        ref="password"
        @contentWatch="res => model.pwd = res"
    />
    <field-text
        label="确认密码"
        style="margin: 15px 0;"
        placeholder="请输入密码"
        type="password"
        ref="checkPWD"
        @contentWatch="res => model.checkPWD = res"
    />
    <login-btn
        msg = "密码重置"
        msg2 = "用户注册"
        @login="resetPassword"
        @register="$router.push('/register')"
    />
  </div>
</template>

<script>
import NavTop from "@/components/common/NavTop";
import LoginBtn from "@/components/common/LoginBtn";
import FieldText from "@/components/common/FieldText";
import {showFailToast, showLoadingToast, showSuccessToast} from "vant";
export default {
  data(){
    return {
      model:{},
      buttonMessage:"发送验证码"
    }
  },
  name: "findPWD",
  components:{
    NavTop,
    FieldText,
    LoginBtn,
  },
  methods:{
    async sendCode(e){
      e.preventDefault();
      e.stopPropagation();
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.model.email)) {
        this.$refs.mail.err = true
        this.$refs.mail.content = ""
        this.$refs.mail.errMsg = "请输入正确的邮箱格式"
        return;
      }
      let data = {"email": this.model.email}
      showLoadingToast({
        message: '验证码发送中...',
        forbidClick: true,
      })
      await this.$user_http.post("/user/sendCode", data,  {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }
    ).then((res)=>{
        if (res.data.code==626){
             setTimeout(()=>{
               showFailToast("邮箱未注册！")
               return
             }, 1000)
           }
        if (res.data.code==0){
          setTimeout(()=>{
            this.buttonMessage = "验证码已发送"
            return
          }, 1000)
        }
      }).catch(err=>{
        showFailToast("网络链接失败!请检查网络！或稍后再试")
        console.error('Error fetching data:', err);
        return
      })
      return false;
    },
    async resetPassword() {
      let regx = /^.{6,16}$/
      if (!this.model.pwd || !regx.test(this.model.pwd)) {
        this.$refs.password.err = true
        this.$refs.password.content = ""
        this.$refs.password.errMsg = "请输入6~16位的密码"
        return;
      }
      if (this.model.pwd != this.model.checkPWD) {
        this.$refs.checkPWD.err = true
        this.$refs.checkPWD.content = ""
        this.$refs.checkPWD.errMsg = "确认密码不一致"
        return;
      }
      let data = {'email':this.model.email, 'password':this.model.pwd, 'code':this.model.code};
      showLoadingToast({
        message: '密码修改中...',
        forbidClick: true,
      })
      await this.$user_http.post("/user/findPass", data).then((res)=>{
        if (res.data.code==0){
          setTimeout(()=>{
            showSuccessToast("密码修改成功！")
            this.$router.push("/login")
            return
          }, 1000)
        }
        else if (res.data.code==404){
          setTimeout(()=>{
            showFailToast("验证码错误！")
            return
          }, 1000)
        }
      }).catch(err=>{
        showFailToast("网络链接失败!请检查网络！或稍后再试")
        console.error('Error fetching data:', err);
        return
      })
    }
  }
}
</script>

<style scoped>

</style>
